import { singleMap } from "./singleMap";
import { doubleMap } from "./doubleMap";
import { swipeMap } from "./swipeMap";
import { spyMap } from "./spyMap";

const MapFunction = (mode) => {
    if(mode === "singleMap") {
        return singleMap;
    } else if(mode === "doubleMap") {
        return doubleMap;
    } else if(mode === "swipeMap") {
        return swipeMap;
    } else if(mode === "spyMap") {
        return spyMap;
    }
}

export default MapFunction;